import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import * as htmlToImage from 'html-to-image';
import premier_destin_badge_empty from 'premier_destin_badge_empty.png';
import review_badge from 'review_badge.png';

export default function CodeSnippet({ type, title, link }) {
  const isBusiness = type === 'premier-business';

  const imageRef = useRef(null);
  const businessSnippetRef = useRef(null);
  const reviewSnippetRef = useRef(null);

  useEffect(() => {
    const imageContainerNode = imageRef && imageRef.current;
    const businessSnippetNode =
      businessSnippetRef && businessSnippetRef.current;
    const reviewSnippetNode = reviewSnippetRef && reviewSnippetRef.current;

    htmlToImage
      .toPng(imageContainerNode)
      .then(dataUrl => {
        imageContainerNode.parentElement.innerHTML = `
          <img src="${dataUrl}" alt="" style="width:100%;height:100%;" />
        `;

        const snippetInput = document.querySelector(
          isBusiness ? '.premier-business-snippet' : '.review-snippet'
        );

        snippetInput.value = (isBusiness
          ? businessSnippetNode
          : reviewSnippetNode
        ).outerHTML;
      })
      .catch(error => {
        console.error('Oops, something went wrong!', error);
      });
  }, [isBusiness]);

  const copySnippet = () => {
    const businessSnippetNode =
      businessSnippetRef && businessSnippetRef.current;
    const reviewSnippetNode = reviewSnippetRef && reviewSnippetRef.current;

    const hiddenInput = document.createElement('input');
    hiddenInput.value = (isBusiness
      ? businessSnippetNode
      : reviewSnippetNode
    ).outerHTML;
    document.body.appendChild(hiddenInput);
    hiddenInput.select();
    document.execCommand('copy');
    document.body.removeChild(hiddenInput);
    // toast.success('Copied link to clipboard');
    const event = new CustomEvent('toast-message', {
      detail: 'Copied snippet to clipboard',
    });
    document.dispatchEvent(event);
  };

  if (isBusiness)
    return (
      <>
        <section id="premier-business-snippet" className="code-snippet-wrapper">
          <a
            href={`${window.location.origin}${link}`}
            target="_blank"
            rel="noopener noreferrer"
            ref={businessSnippetRef}
            style={{
              display: 'block',
              position: 'relative',
              width: '155px',
              height: '115px',
            }}
          >
            <div ref={imageRef} style={{ width: '100%', height: '100%' }}>
              <img
                src={premier_destin_badge_empty}
                alt=""
                style={{ width: '100%', height: '100%' }}
              />
              <p
                style={{
                  position: 'absolute',
                  width: '80%',
                  textAlign: 'center',
                  top: '35%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  fontSize: '9px',
                  lineHeight: '11px',
                  color: '#000000',
                }}
              >
                {title}
              </p>
            </div>
          </a>
        </section>
        <p className="code-snippet-image-preview">Image Preview</p>
        <button type="button" className="btn btn--dark" onClick={copySnippet}>
          Copy to clipboard
        </button>
      </>
    );

  return (
    <>
      <section id="premier-business-snippet" className="code-snippet-wrapper">
        <a
          href={`${window.location.origin}${link}#reviews`}
          target="_blank"
          rel="noopener noreferrer"
          ref={reviewSnippetRef}
          style={{
            display: 'block',
            position: 'relative',
            width: '155px',
            height: '115px',
          }}
        >
          <div ref={imageRef} style={{ width: '100%', height: '100%' }}>
            <img
              src={review_badge}
              alt=""
              style={{ width: '100%', height: '100%' }}
            />
          </div>
        </a>
      </section>
      <p className="code-snippet-image-preview">Image Preview</p>
      <button type="button" className="btn btn--dark" onClick={copySnippet}>
        Copy to clipboard
      </button>
    </>
  );
}

CodeSnippet.propTypes = {
  type: PropTypes.oneOf(['premier-business', 'review']).isRequired,
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};
